var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('css-transition',_vm._g(_vm._b({},'css-transition',[_vm.$attrs, {enterClass: _vm.enterClass, leaveClass: _vm.leaveClass}],false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }